"use strict";

var userCardWidget = function () {
  var userCardWidgetParams = {};

  function changeUserDataRequest(callback) {
    $.ajax({
      type: 'GET',
      url: userCardWidgetParams.url.changeUserData,
      success: function success(template) {
        callback(template);
      },
      error: function error() {
        modalDialog.showBaseWnd({
          title: 'Ошибка получения данных',
          buttons: [{
            title: 'Хорошо',
            big: true,
            primary: true
          }],
          onDrawContent: function onDrawContent() {
            return 'В текущий момент данные не могут быть получены. Мы уже знаем о проблеме и работаем над ее устранением.';
          }
        });
      },
      complete: function complete() {
        modalDialog.busyIndicator(false);
      }
    });
  }

  function setParams(userCardParams) {
    userCardWidgetParams = $.extend({}, userCardWidgetParams, userCardParams);
  }

  function unbindHandlers() {
    $(document).off('click', '#changeUserDataBtn');
  }

  function showResult(data) {
    if (data.Success) {
      modalDialog.showBaseWnd({
        title: 'Запрос принят',
        buttons: [{
          title: 'Хорошо',
          big: true,
          primary: true
        }],
        onDrawContent: function onDrawContent() {
          return data.Result;
        }
      });
    } else {
      modalDialog.showBaseWnd({
        title: 'Ошибка',
        buttons: [{
          title: 'Хорошо',
          big: true,
          primary: true
        }],
        onDrawContent: function onDrawContent() {
          return data.Result;
        }
      });
    }
  }

  function bindHandlers() {
    $(document).on('click', '#changeUserDataBtn', function () {
      modalDialog.busyIndicator(true);
      changeUserDataRequest(function (template) {
        var $changeDataModal = $('.modal-wrapper').html(template); // init mask on phone field

        $changeDataModal.showAsModal({
          isVertical: true,
          buttons: [{
            title: 'Отправить',
            big: true,
            primary: true,
            wide: true,
            onClick: function onClick() {
              var isValid = modalService.validateModalForm();

              if (isValid) {
                // improve submitRequest API
                modalService.submitRequest(showResult);
              }

              return isValid;
            }
          }],
          afterOpen: function afterOpen() {
            modalService.setTitle();
          }
        });
      });
    });
  }

  function cacheNodes() {}

  function init(userCardParams) {
    unbindHandlers();
    setParams(userCardParams);
    cacheNodes();
    bindHandlers();
  }

  return {
    init: init
  };
}();